
import { Vessel, VesselAuction, ExemptionVessel, IVesselQuotaData, IQuotaTransaction } from "interface/vessel";
import { AxiosApi } from "./index";



export async function getAllVessel({ text, resKto, source, date, rn, id, allowCallSign = false }: { text: string, date?: Date, allowCallSign?: boolean, source?: string, resKto?: number, id?: number, rn?: string }) {
    const apiUri = "Vessel/GetAll"

    try {
        const vessel = await AxiosApi.get<Vessel[]>(apiUri, {
            params: {
                text, resKto, source, date, id, allowCallSign, rn
            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getVesselFilter(text: string, returnAll = false) {
    const apiUri = "Vessel/GetAll"

    try {
        const vessel = await AxiosApi.get<Vessel[]>(apiUri, {
            params: {
                text, returnAll
            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getUserSettingVesselssFilterApi() {
    const apiUri = "administration/UserSettingVessels"

    try {
        const buyer = await AxiosApi.get<Vessel[]>(apiUri, {})
        return buyer.data
    } catch (error: any) {
        throw error
    }
}

export async function getRegistrationVessels(text: string, returnAll = false) {
    const apiUri = "vessel/registration-vessels"

    try {
        const vessel = await AxiosApi.get<Vessel[]>(apiUri, {
            params: {
                text, returnAll
            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getUserVesselFilter(text: string) {
    const apiUri = "Vessel/user"

    try {
        const vessel = await AxiosApi.get<Vessel[]>(apiUri, {
            params: {
                text
            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}
export async function getAuctionVesselNO(text: string) {
    const apiUri = "Vessel/auctionedVessels"

    try {
        const vessel = await AxiosApi.get<VesselAuction[]>(apiUri, {
            params: {
                text,
                source: "rn"

            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}
export async function getAuctionVesselByName(text: string) {
    const apiUri = "Vessel/auctionedVessels"

    try {
        const vessel = await AxiosApi.get<VesselAuction[]>(apiUri, {
            params: {
                text,
                source: "nm"
            }
        })

        //console.log('vessel data', vessel.data);

        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getVesselByIdApi(vesselId: string) {
    const apiUri = "Vessel/Get"

    try {
        const vessel = await AxiosApi.get<Vessel>(apiUri, {
            params: {
                vesselId
            }
        })
        return vessel.data
    } catch (error : any) {
        throw error
    }
}
export async function getVesselDetailApi(vesselId: string,regNo: string, vesselName: string) {
    const apiUri = "Vessel/Detail"

    try {
        const vessel = await AxiosApi.get<Vessel>(apiUri, {
            params: {
                vesselId,
                regNo,
                vesselName
            }
        })
        return vessel.data
    } catch (error : any) {
        throw error
    }
}


export async function getExemptionVesselApi(vesselId: string, lastCatchDate: Date) {
    const apiUri = "Vessel/ExemptionVessels"

    try {
        const vessel = await AxiosApi.get<ExemptionVessel[]>(apiUri, {
            params: {
                vesselId,
                lastCatchDate
            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getVesselQuotasApi(vesselId: string, vesselRegNo: string, year: number) {
    const apiUri = "Vessel/Quotas"

    try {
        const response = await AxiosApi.get<IVesselQuotaData[]>(apiUri, {
            params: { vesselId, vesselRegNo, year }
        })

        //console.log('quota response', response.data);
        return response.data
    } catch (error) {
        throw error
    }
}

export async function getQuotaTransactionApi(
    accountNumber: string,
    validFrom: string,
    validTo: string,
    source: string,
) {
    const apiUri = "Vessel/QuotaTransactions"

    try {
        const response = await AxiosApi.get<IQuotaTransaction[]>(apiUri, {
            params: { accountNumber, validFrom, validTo, source }
        })
        return response.data
    } catch (error) {
        throw error
    }
}
